import { Controller, useFormContext, useWatch } from 'react-hook-form';
import css from './index.module.scss';
import SelectLabel from '@components/common/select-label';
import { CURRENCY, ENQUIRY_TYPE, TAX_OPTIONS, WEIGHT_SYSTEM } from '@helpers/constants';
import { TextField } from '@components/common';
import { useEffect } from 'react';
import { IWeightChildOption } from '@helpers/types/quotes';

interface IEnquiryGenericInformationProps {
  setQuoteFormState: any;
  selectedWeightSystemChildOptions: IWeightChildOption[];
  isExpanded: boolean;
}

const DomesticGenericInformation = (props: IEnquiryGenericInformationProps) => {
  const { setQuoteFormState, selectedWeightSystemChildOptions, isExpanded } = props;

  const { control, setValue } = useFormContext();

  const currency1 = useWatch({
    name: `genericInformation.currency1`,
    control
  });

  const weightSystem = useWatch({
    name: `genericInformation.weightSystem`,
    control
  });

  useEffect(() => {
    setQuoteFormState((prevState: any) => {
      if (!currency1) {
        return {
          ...prevState,
          selectedCurrency: CURRENCY
        };
      }

      return {
        ...prevState,
        selectedCurrency: [currency1]
      };
    });
  }, [currency1, setQuoteFormState]);

  useEffect(() => {
    try {
      setQuoteFormState((prevState: any) => {
        return {
          ...prevState,
          selectedWeightSystemChildOptions: weightSystem?.childOptions
        };
      });

      setValue(
        'genericInformation.primaryUnit',
        weightSystem?.childOptions.find((item: IWeightChildOption) => item.default === true)
      );
    } catch (error) {
      return;
    }
  }, [weightSystem, setValue, setQuoteFormState]);

  return (
    <main>
      {isExpanded && (
        <div className={css.formWrapper}>
          <div className={css.rowWrapper}>
            <Controller
              name={`genericInformation.currency1`}
              control={control}
              render={({ field, fieldState }) => (
                <SelectLabel
                  {...field}
                  options={CURRENCY}
                  required
                  label="Currency 1"
                  error={fieldState.invalid}
                  helperText={fieldState.error?.message}
                />
              )}
            />
            <Controller
              name={`genericInformation.weightSystem`}
              control={control}
              render={({ field, fieldState }) => (
                <SelectLabel
                  {...field}
                  options={WEIGHT_SYSTEM}
                  required
                  label="Weight System"
                  error={fieldState.invalid}
                  helperText={fieldState.error?.message}
                />
              )}
            />
          </div>

          <div className={css.rowWrapper}>
            <Controller
              name={`genericInformation.primaryUnit`}
              control={control}
              render={({ field, fieldState }) => (
                <SelectLabel
                  {...field}
                  options={selectedWeightSystemChildOptions}
                  required
                  label="Primary Unit"
                  error={fieldState.invalid}
                  helperText={fieldState.error?.message}
                />
              )}
            />
            <Controller
              name={`genericInformation.draftDealName`}
              control={control}
              render={({ field, fieldState }) => (
                <TextField
                  {...field}
                  label="Deal Name"
                  error={fieldState.invalid}
                  helperText={fieldState.error?.message}
                />
              )}
            />
          </div>

          <div className={css.rowWrapper}>
            <Controller
              name={`genericInformation.taxType`}
              control={control}
              render={({ field, fieldState }) => (
                <SelectLabel
                  {...field}
                  options={TAX_OPTIONS}
                  required
                  label="Tax Type"
                  error={fieldState.invalid}
                  helperText={fieldState.error?.message}
                />
              )}
            />
          </div>
        </div>
      )}
    </main>
  );
};

export default DomesticGenericInformation;
